import * as React from 'react'
function SvgFilter(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M33.816 6.968A1.752 1.752 0 0032.25 6H7.75c-.663 0-1.269.374-1.566.968A1.756 1.756 0 006.35 8.8L16.5 22.333v9.917c0 .968.782 1.75 1.75 1.75h3.5c.968 0 1.75-.782 1.75-1.75v-9.917L33.65 8.8c.397-.53.46-1.239.166-1.832z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgFilter
